import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { LicensedDesignProfessionalSearchAppModule } from './app/app.module';


declare let __webpack_public_path__: any;
if (environment.production) {
  enableProdMode();
  if (window['ebbCdn']) {
    __webpack_public_path__ = window['ebbCdn'];
  }
}
platformBrowserDynamic()
  .bootstrapModule(LicensedDesignProfessionalSearchAppModule)
  .catch(err => console.error(err));
